<template>
	<div class="instance-autocomplete" v-on:click.stop>
		<!-- <button v-on:click="test()">Test</button> -->
		<!-- input to enter search string -->
		<button v-on:click.stop="comboKeyEnter"
			class="button"
			:disabled="defaultItem.value==filterString"
			>
			<img class="button-image"
				:src="require('../assets/Check.png')"
				v-bind:class="{disabled: defaultItem.value==filterString}"/>	
			</button>
		<div class="dropdown">
			<input class="input"
				ref="filterInput"
				v-bind:size='textLen'
				v-model="filterInput"
				contenteditable='true'
				v-on:keydown="comboKeyDown"
				v-on:keydown.enter="comboKeyEnter"
				v-on:focus.stop="onFocus"
				v-on:blur="onBlur"
			/>
			<ul class="dropdown--list"
				:class='{"dropdown--list-show": sortedInstances.length>0}'
				:style="dropdownStyle">
				<li class="dropdown--li"
					:class='{"dropdown--li-active": listPointer === index}'
					v-for="(item, index) in sortedInstances" v-bind:key="index"
					v-text="item.value"
					v-on:click.stop="onListClick(item,index)"/>
			</ul>
		</div>
	</div>
</template>

<script>
	import getNodInstances from '../graphql/server/Instance/NodInstances.gql'
	
	export default {
		name: 'InstanceAutocomplete',
		props: {
			authStatus: {
				type: Object,
				required: true,
			},
			defaultItem:{
				type: Object,
				required: false,
				default:() => ({}),
			},
			vars:{
				type:Object,
				required:true
			},
		},
		data() {
			return {
				code: null,
				NodInstances: [],
				filterInput: '',   	// contains all characters the user has entered
				filterString: '',
				showMatches: false,  // hide/show the search results
				listPointer: -1,   // determine which result is selected
				offset: 0, // the first result to return (use other than 0 for pagination, not req here)
				first: 5,   // number of search results to return
				dropdownRect: { top: 0, left: 0, width: 0 }
			}
		},
		apollo: {
			NodInstances:{
				query: getNodInstances,
				fetchPolicy: 'no-cache',
				skip() { return this.skipQuery() },
				variables() {
					return {
						options: {
							limit: this.first,
							offset: this.offset,
							// Remove server-side sorting to let client-side sorting take over
							// sort: { value: "ASC" },
						},
						where: {
							isCollection: this.vars.isCollection ? true : false,
							nodID: this.vars.nodID,
							returnFilters: this.vars.returnFilters ? true : false, // true = return instances, false = return filters
							userID: this.authStatus.userID,
							value_CONTAINS: this.filterString,
						}
					}
				},
			},
		},
		methods: {
			updateRect() {
				if (this.$refs.filterInput) {
					const rect = this.$refs.filterInput.getBoundingClientRect();
					this.dropdownRect = {
						top: rect.bottom,
						left: rect.left,
						width: rect.width
					};
				}
			},
			skipQuery() {
				if (this.vars.editOnly) { // alway skip Query
					return true
				} else if (this.filterInput === '' || this.filterInput === undefined) {
					// Don't clear results when input is empty - this allows the dropdown to stay open
					// and show all available options when the input is focused but empty
					return true // skip because there is nothing typed
				} else {
					return false
				}
			},
			comboKeyDown(event) { // navigate through the combo box and list and set this.selection accordingly
				let key = event.keyCode
				let pointer = this.listPointer
				let length 	= this.sortedInstances.length
				switch(key){
					case 9: // tab
						if(length > 0 && pointer == -1){this.listPointer = 0}
						this.showMatches = false
						break
					case 38: // arrow up
						event.preventDefault();
						pointer >= 0 && pointer < length ? this.listPointer-- : this.listPointer = length-1
						break
					case 40: // arrow down
						event.preventDefault();
						pointer >= -1 && pointer < length-1 ? this.listPointer++ : this.listPointer = -1
						break
					case 27: // esc
						this.showMatches = false
						this.filterInput = ''
						this.emitSelection(null)
						// this.$emit('selectedItem', {item: null, code: 0})
						break
					default:
						// Reset pointer on typing so auto-match can take over
						if (key !== 13 && key !== 16 && key !== 17 && key !== 18) {
							this.listPointer = -1
						}
						break
				}
			},
			comboKeyEnter(event) { // make selection by typing enter
				// console.log('comboKeyEnter')
				if (event) event.preventDefault()
				this.emitSelection(this.selection)
			},
			onListClick(item, index) { // make selection by click
				this.listPointer = index
				this.emitSelection(this.selection)
			},
			emitSelection(selection) {
				// console.log('emitSelection', selection)s

				if (!selection || (selection.value === '' && !selection.ID)) {
					this.$emit('selectedItem', { item: null, code: 0 })
					return
				}

				const retVar = { item: selection }

				if (selection.ID) {
					if (this.defaultItem && selection.ID === this.defaultItem.ID) {
						retVar.code = (selection.value !== this.defaultItem.value) ? 1 : 0
					} else {
						retVar.code = 2
					}
				} else {
					retVar.code = 3
				}

				this.$emit('selectedItem', retVar)

				this.listPointer = -1
				this.showMatches = false
			},
			onFocus() {
				// When input gets focus, show the dropdown if there are results
				// or if we should show all available options when empty/undefined
				if (this.NodInstances.length > 0 || this.filterInput === '' || this.filterInput === undefined) {
					this.showMatches = true
					this.updateRect()
				}
			},
			onBlur(event) {
				// Use setTimeout to allow click events on dropdown items to be processed first
				setTimeout(() => {
					// Only hide dropdown if the blur was not caused by clicking on a dropdown item
					if (!this.$el.contains(event.relatedTarget)) {
						this.showMatches = false
					}
				}, 200)
			},
		},
		watch: {
			NodInstances: function(newResults) {
				// Add null check to prevent "can't access property Symbol.iterator, newResults is null" error
				if (newResults && newResults.length > 0) {
					this.updateRect();
					this.showMatches = true

					// Auto-match: if input matches a result exactly, highlight it
					// We need to find the index in the sorted array, not the original array
					const sortedResults = this.sortedInstances;
					const matchIndex = sortedResults.findIndex(item => item.value.toLowerCase() === this.filterInput.toLowerCase())
					if (matchIndex !== -1) {
						this.listPointer = matchIndex
					}
				} else {
					this.showMatches = false
				}
			},
			filterInput: function(newVal) {
				this.filterString = newVal

				// Clear results when backspacing to empty
				if (newVal === '') {
					this.listPointer = -1
					this.NodInstances = [] // Clear the results
					this.showMatches = false
				}
			},
		},
		computed: {
			dropdownStyle() {
				return {
					position: 'fixed',
					top: `${this.dropdownRect.top}px`,
					left: `${this.dropdownRect.left}px`,
					width: `${this.dropdownRect.width}px`,
					minWidth: '200px' // Ensure it's readable
				};
			},
			sortedInstances() {
				// Return an empty string if there are no nodeInstances
				if (!this.NodInstances || this.NodInstances.length === 0) {
					return "";
				}

				// Return sorted instances for display (case-insensitive)
				return [...this.NodInstances].sort((a, b) => {
					return a.value.toLowerCase().localeCompare(b.value.toLowerCase());
				});
			},
			queryVars() {
				const temp = {
					options: {
						limit: this.first,
						offset: this.offset,
						// Removed server-side sorting to allow client-side sorting to work properly
						// sort: { value: "ASC" },
					},
					where: {
						isCollection: this.vars.isCollection ? true : false,
						nodID: this.vars.nodID,
						returnFilters: this.vars.returnFilters ? true : false, // true = return instances, false = return filters
						userID: this.authStatus.userID,
						value_CONTAINS: this.filterString,
					}
				}
				return temp
			},
			textLen(){
				const currentLen = this.filterInput ? this.filterInput.length : 0
				const defaultLen = this.defaultItem.value ? this.defaultItem.value.length : 0
				const maxLen = Math.max(currentLen, defaultLen, 10)
				return maxLen
			},
			selection: function (){
				if (this.listPointer !== -1 && this.sortedInstances[this.listPointer]) {
					return this.sortedInstances[this.listPointer]
				}

				if (this.vars.editOnly && this.defaultItem) {
					return {
						...this.defaultItem,
						value: this.filterInput
					}
				}

				return {
					__typename: "Instance",
					ID: null,
					value: this.filterInput,
					isFilter: null,
					isPinned: false
				}
			},
		},
		mounted(){
			this.$refs.filterInput.focus()
			this.$nextTick(function () {
				this.filterInput = this.defaultItem.value || ''
				this.updateRect();
			})
			window.addEventListener('scroll', this.updateRect, true);
			window.addEventListener('resize', this.updateRect);
		},
		beforeUnmount() {
			window.removeEventListener('scroll', this.updateRect, true);
			window.removeEventListener('resize', this.updateRect);
		}
	}
</script>

<style scoped>

	.instance-autocomplete{
		background-color: white;
		z-index: 1000;
	}

	.button{
		border: 1px solid black;
		border-radius: 4px;
		display: inline-block;
		height: 24px;
		min-width: 17px;
		margin-left: .5px;
		margin-right: .5px;
/*		background-color: white;*/
	}

	.button:hover{
		background-color: #a6f4e5;
	}

	.button-image{
		height: 15px;
		display:flex;
	}

	.input{
		border: 1px solid black;
		border-collapse: collapse;
		height: 22px;
		margin-left: .5px;
		margin-right: .5px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.dropdown{
		display: inline-block;
		min-width: 10px;
		overflow: visible;
	}

	.dropdown--list {
		display:none;
		border: 1px solid black;
		background-color: #cff5a9;
		padding:5px;
		position: fixed;
		margin: 0;
		z-index: 99999;
	}

	.dropdown--list-show{
		display:block;
	}

	.dropdown--li {
		list-style-type: none;
		height: 24px;
		padding-left: 5px;
		padding-right: 5px;
	}

	.dropdown--li:hover {
		background-color: #a6f4e5;
		cursor: pointer;
	}

	.dropdown--li-active {
		background-color: #4AAE9B;
		color: white;
	}

	.disabled{
		opacity: 0.3;
	}

</style>